export default __webpack_public_path__ + "static/media/UZ.b5c48d41.ico";